var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import CollaboratorPacketTicket from './Model';
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
var CollaboratorPacketTicketsStore = /** @class */ (function () {
    function CollaboratorPacketTicketsStore() {
        var _this = this;
        this.loading = false;
        this.eagerCollaboratorPacketTicket = ['tickets'];
        this.read = function (id, range) {
            if (range === void 0) { range = { from: new Date(new Date().setMonth(new Date().getMonth() - 1)), to: new Date() }; }
            _this.loading = true;
            if (id) {
                return api.get("collaboratorPacketTickets/".concat(id, "?eager=").concat(_this.eagerCollaboratorPacketTicket));
            }
            console.log();
            return api.get("collaboratorPacketTickets?eager=".concat(_this.eagerCollaboratorPacketTicket)).then(_this.set);
        };
        this.set = function (values) {
            console.log('values: ', values);
            _this.loading = false;
            _this.collaboratorPacketTickets = values.map(function (value) { return new CollaboratorPacketTicket(value); });
        };
    }
    __decorate([
        observable
    ], CollaboratorPacketTicketsStore.prototype, "collaboratorPacketTickets", void 0);
    __decorate([
        observable
    ], CollaboratorPacketTicketsStore.prototype, "collaboratorPacketTicket", void 0);
    __decorate([
        observable
    ], CollaboratorPacketTicketsStore.prototype, "loading", void 0);
    __decorate([
        action
    ], CollaboratorPacketTicketsStore.prototype, "read", void 0);
    __decorate([
        action
    ], CollaboratorPacketTicketsStore.prototype, "set", void 0);
    return CollaboratorPacketTicketsStore;
}());
export default CollaboratorPacketTicketsStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorPacketTickets/Store.ts
// module id = 741
// module chunks = 0